
import { useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/components/ui/use-toast";

export const useStrategyStatus = (loadStrategiesCallback: () => Promise<void>) => {
  const [isUpdatingStatus, setIsUpdatingStatus] = useState(false);
  const { toast } = useToast();

  const toggleStrategyStatus = async (strategyId: string, isPro: boolean) => {
    setIsUpdatingStatus(true);
    try {
      const { error } = await supabase
        .from('strategy')
        .update({ plan: isPro ? 'free' : 'pro' })
        .eq('id', strategyId);

      if (error) throw error;

      toast({
        title: "Success",
        description: "Strategy status has been updated",
      });

      await loadStrategiesCallback();
    } catch (error) {
      console.error('Error updating strategy:', error);
      toast({
        title: "Error",
        description: "Failed to update status",
        variant: "destructive",
      });
    } finally {
      setIsUpdatingStatus(false);
    }
  };

  const toggleStrategyActive = async (strategyId: string, isActive: boolean) => {
    setIsUpdatingStatus(true);
    try {
      const { error } = await supabase
        .from('strategy')
        .update({ active: !isActive })
        .eq('id', strategyId);

      if (error) throw error;

      toast({
        title: "Success",
        description: `Strategy has been ${!isActive ? 'activated' : 'deactivated'}`,
      });

      await loadStrategiesCallback();
    } catch (error) {
      console.error('Error updating strategy active state:', error);
      toast({
        title: "Error",
        description: "Failed to update strategy status",
        variant: "destructive",
      });
    } finally {
      setIsUpdatingStatus(false);
    }
  };

  return { 
    toggleStrategyStatus, 
    toggleStrategyActive, 
    isUpdatingStatus 
  };
};
